import type { ReferenceLinkInput } from './types'

// Pure link helpers shared by the editor table and the add/edit dialog. Kept
// out of ReferenceLinksEditor.tsx so the dialog can import them without the
// editor having to import the dialog (which would close an import cycle).

export const isValidUrl = (value: string): boolean =>
  /^https:\/\//i.test(value.trim())

export const isValidDraft = (draft: ReferenceLinkInput): boolean =>
  Boolean(draft.name.trim()) && Boolean(draft.url.trim()) && isValidUrl(draft.url)

export const newLink = (
  allowedLinkTypes: string[],
  displayOrder: number,
): ReferenceLinkInput => ({
  link_type: allowedLinkTypes[0] ?? 'fix_guide',
  market: null,
  name: '',
  url: '',
  description: '',
  display_order: displayOrder,
})

export const marketLabel = (m: ReferenceLinkInput['market']): string =>
  m === null ? 'All markets' : m

export const syncDisplayOrder = (
  links: ReferenceLinkInput[],
): ReferenceLinkInput[] => links.map((l, i) => ({ ...l, display_order: i }))
